
import { createContext, useContext, useEffect, useState } from 'react';
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    sendPasswordResetEmail,
    signOut,
    setPersistence,
    browserSessionPersistence
} from "firebase/auth";
import { auth } from '../contextos/firebase';
import { collectionGroup, getDocs } from "firebase/firestore";

import { db } from './firebase';
const authContext = createContext();

export const useAuth = () => {
    const context = useContext(authContext);
    return context;
}

export const AuthProvider = ({ children }) => {

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [Rol, setRol] = useState(null);
    const [PerfilUsuario, setPerfilUsuario] = useState(null);
    const [Token, setToken] = useState(null);

    const ObtenerToken = async () => {
        try {
            const response = await fetch('https://SmartFeCr.com:2020/SmartContrackBack/api/Login/authenticate', {
                "method": "POST",
                "headers": {
                    "x-rapidapi-host": "fairestdb.p.rapidapi.com",
                    "x-rapidapi-key": "apikey",
                    "content-type": "application/json",
                    "accept": "application/json"
                },
                "body": JSON.stringify({
                    "Username": "smartfecr",
                    "Password": "Kz3!vN8#qWx1RuT"
                })
            });

            if (response.status === 200) {
                const data = await response.json();
                setToken(data);
            } else if (response.status === 401) {
                console.log(await response.json())
                setToken(null);
            }
            else {
             console.log(response.status)
            }
        } catch (error) {
            setToken(null);
        }
    }

    const CambiaPerfil = (e) => {
        const { value } = e.target;
        const perfil = Rol.find(item => item.IdCia === parseInt(value));
        console.log(perfil);
        setPerfilUsuario(perfil);
    }

    async function pideReseteo(email) {
        // console.log(email)
        try {
            await sendPasswordResetEmail(auth, email);
            return "Correo de restablecimiento enviado correctamente.";
        } catch (error) {
            return `Error al enviar correo: ${error.message}`;
        }
    }


    const getById = async (userUid) => {
        const querySnapshot = await getDocs(collectionGroup(db, userUid));

        const documents = [];
        querySnapshot.forEach((doc) => {
            if (doc.id === 'Datos') {
                documents.push({ id: doc.id, ...doc.data() });
            }
        });
        console.log(documents);
        setRol(documents)
        setPerfilUsuario(documents[0])

        /*
        const docRef = doc(db,"Roles",userUid);
        const docSnap = await getDoc(docRef)
        setRol(docSnap.data())
        console.log(docSnap.data())
     
       
        const querySnapshot = await getDocs(collectionGroup(db, "Roles", userUid));

        querySnapshot.forEach((doc) => {
            console.log(`Documento encontrado en Roles: ${doc.id}`, doc.data());
        });

        */
    }

    const signUp = (email, psw) => createUserWithEmailAndPassword(auth, email, psw);
    const signIn = async (email, psw) => {
        try {
            await setPersistence(auth, browserSessionPersistence)
                .then(() => {
                    return signInWithEmailAndPassword(auth, email, psw);
                })
            return await signInWithEmailAndPassword(auth, email, psw)
                .catch((e) => { throw e })
        } catch (error) {
            throw error
        }

    };
    const signout = () => {
        setUser(null);
        setToken(null);
        return signOut(auth);
    }



    useEffect(() => {
        const unsubscirbe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);

            setLoading(false);

        })
        return () => { unsubscirbe() }
    }, []);

    useEffect(() => {
        if (user) {
            getById(user.uid)
        }
    }, [user]);

    return (
        <authContext.Provider value={{
            signUp, signIn, signout, user, Rol,
            loading, pideReseteo, CambiaPerfil, PerfilUsuario, ObtenerToken, Token
        }}>
            {children}
        </authContext.Provider>
    );

}